<style>
	.goods-company-summary-base{
		float: left;
		width: 100%;
		background-color: #fff;
		font-size: .9em;
		padding:.7em 0;
		margin-top: 5px;
	}
	.goods-company-summary-left,.goods-company-summary-right{
		box-sizing: border-box;
		float: left;
		position: relative;
		height: 100%;
	}
	.goods-company-summary-right {
		float: right;
	}
	.clear-float{
		clear:both;
	}
	.goods-company-summary-left{
		/* width: 100%; */
		padding-left: 1em;
	}
	.goods-company-summary-left>div{
		position: relative;
		height:30px;
		line-height: 30px;
	}
	.goods-company-summary-edit{
		position: absolute;
		right: 7px;
		top: 7px;
		height: 24px;
    line-height: 24px;
    padding-right: 18px;
    font-size: 14px;
    color: #fff;
		background:url(../assets/sift.png) no-repeat right center;
		background-size: auto 14px;
	}
	.goods-company-summary-excel{
		position: absolute;
		right: 50px;
		top: 9px;
		width: 25px;
		height: 25px;
		background:url(../assets/excel.png) no-repeat;
		background-size: contain;
	}
	.lightblack-font{
		color: #353535
	}
	.goods-company-ico,.goods-company-name{
		float: left;
	}
	.goods-company-ico{
		width: 30px;
		height: 30px;
		background:url(../assets/house-ico.png) no-repeat;
		background-size: contain;
	}
	.goods-company-name{
		position: relative;
		font-size: 1.3em;
		margin-left:5px;
	}
	.goods-company-status{
		float:right;
		margin-left:20px;
		background-color: #25a0a3;
		padding: 0 10px;
		color: #fff;
		height: 25px;
		line-height: 25px;
		margin-top: 2px;
		border-radius:2px;
	}
	.goods-company-summary-wrapper{
		box-sizing: border-box;
		width: 100%;
		margin-top: 5px;
		background-color: #fff;
		padding: .7em 1em 40px;
	}
	.goods-company-detail-show{
		margin-left: 10%;
	}
	.goods-company-detail-show-ul{
		float: left;
		width: 100%;
	}
	.goods-company-detail-show-ul li{
		float: left;
		width: 50%;
		font-size: .9em;
		color: #656565;
	}
	.goods-company-detail-name{
		display: block;
		font-size: 1em;
		font-weight: 500;
		color: #000000;
		height: 25px;
		line-height: 25px;
		clear: both;
	}
	.goods-company-house {
		width: 90%;
	}
	.title-font {
		font-size: .9em;
		font-weight: 700;
		color: #656565;
	}

	.goods-company-detail-list{
		display: block;
		border-bottom: solid 1px #eee;
		padding-bottom: .7em;
		margin-bottom:.7em;
	}
	.goods-company-detail-list:last-child{
		border-bottom: none;
		margin-bottom: 0;
	}
	.goods-company-detail-show{
		margin-top: 5px;
		overflow: hidden;
	}
	.gd {
		/* float: right; */
		/* display: inline-block; */
		height: 25px!important;
		padding-top: 5px;
		margin-right: 5px;
	}
	.gd > span {
		display: inline-block;
		vertical-align: top;
	}
	.imp_btn {
		position: absolute;
		right: 55px;
		top: 7px;
	}
	.switch {
		position: relative;
		display: inline-block;
		width: 40px;
		height: 24px;
	}

	.switch input {display:none;}

	.slider {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #ccc;
		-webkit-transition: .4s;
		transition: .4s;
	}
	.slider:before {
		position: absolute;
		content: "";
		height: 18px;
		width: 18px;
		left: 4px;
		bottom: 3px;
		background-color: white;
		-webkit-transition: .4s;
		transition: .4s;
	}

	input:checked + .slider {
		background-color: #25a0a3;
	}

	input:focus + .slider {
		box-shadow: 0 0 1px #2196F3;
	}

	input:checked + .slider:before {
		-webkit-transform: translateX(26px);
		-ms-transform: translateX(26px);
		transform: translateX(14px);
	}

	/* Rounded sliders */
	.slider.round {
		border-radius: 34px;
	}

	.slider.round:before {
		border-radius: 50%;
	}
	.goods-total-1 {
		margin-left: 70px;
	}
	.wind-bottom-btn-bar{
		position: fixed;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: #fff;
		height: 42px;
		display: flex;
		justify-content: flex-end;
	}
	.wind-button{
		align-items: center;
		display: flex;
		flex-direction: row;
		justify-content: center;
		border: 0 none;
		font-size: 14px;
		height: 42px;
		line-height: 42px;
		position: relative;
		box-sizing: border-box;
		overflow: hidden;
		white-space: nowrap;
		padding: 0 28px;
	}
</style>
<style scoped>
.list-container {
  flex: 1;
  overflow: hidden
}
.list-content {
  position: relative;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  z-index: 1
}
.list-content .list-head, .list-content .list-bottom {
  display: flex;
  position: relative;
  z-index: 99;
  height: 12vw;
}
.list-body .list-body-main{
  width: fit-content;
}
.list-content .list-column,
.list-content .fixed-column{
  width: 24vw;
  padding-left: 4.267vw;
  line-height: 11.733vw;
  height: 12vw;
  background-color: #fff;
  font-size: 3.733vw;
  font-weight: bold;
  box-sizing: border-box;
}
.list-content .item-name,
.list-content .item-info {
  position: relative;
  display: flex;
  align-items: center;
  width: 24vw;
  padding: 1.333vw 0 1.333vw 4.267vw;
  line-height: 4.8vw;
  min-height: 11.733vw;
  font-size: 3.733vw;
  background-color: #fff;
  box-sizing: border-box
}
.list-content .fixed-column,
.list-content .item-name{
  width: 32vw;
}
.list-content .column-content,
.list-content .total-content {
  display: flex;
}
.list-content .item-list {
  display: flex
}
.total-content .list-column{
  width: auto;
}
</style>
<template>
<div class="edi-allorderbill">
	<navbar title="货品汇总-餐企"></navbar>
	<span class="goods-company-summary-edit" @click="summaryFilter">筛选</span>
	<excel-export v-if="!midware" v-show="goodsTotalInfo.select_detail==0" @excelExport="sendExcel"></excel-export>
	<span class="goods-company-summary-excel imp_btn" v-show="goodsTotalInfo.select_detail==1" @click="sendExcelSd()"></span>
	<div class="common-scroll" id="common-scroll"  @scroll="refresh" style="bottom: 42px">
		<div class="container" v-if="!midware" v-show="!loading">
			<div class="goods-company-summary-base">
				<div class="goods-company-summary-left">
					<div>
						<span>
							<i class="goods-company-ico"></i><strong class="goods-company-name">{{store.goodsTotalInfo.restaurant_name}}</strong>
						</span>
					</div>
					<div class="lightblack-font">
						<span v-if="goodsTotalInfo.sort_method === '0'">订货日期：</span>
						<span v-if="goodsTotalInfo.sort_method === '1'">到货日期：</span>
						{{store.goodsTotalInfo.start_date}} 至 {{store.goodsTotalInfo.end_date}}
					</div>
				</div>
				<div class="goods-company-summary-right" v-show="goodsTotalInfo.select_detail==1">
					<div class="gd">
						<label class="switch">
							<input type="checkbox" v-model="gord">
							<div class="slider round"></div>
						</label>
						<span>区分门店</span>
					</div>
					<div class="gd">
						<label class="switch">
							<input type="checkbox" v-model="groupByHouse">
							<div class="slider round"></div>
						</label>
						<span>区分仓库</span>
					</div>
				</div>
			</div>
			<div class="clear-float"></div>
			<!-- 明细条目栏 -->
			<div class="goods-company-summary-wrapper" v-if="goodsTotalInfo.select_detail==0">
				<div v-for="billCount in billCounts" class="goods-company-detail-list">
						<span v-if="billCount.bill_state === 10" class="goods-company-status">未处理</span>
						<span v-if="billCount.bill_state === 11" class="goods-company-status">待发货</span>
						<span v-if="billCount.bill_state === 12" class="goods-company-status">已发货</span>
						<span v-if="billCount.bill_state === 13" class="goods-company-status">已收货</span>
						<span v-if="billCount.bill_state === 14" class="goods-company-status">已收货 已确认</span>
						<span v-if="billCount.bill_state === 20" class="goods-company-status">未确认</span>
						<span v-if="billCount.bill_state === 21" class="goods-company-status">已确认</span>
					<strong class="goods-company-detail-name">{{billCount.organName ? billCount.organName : billCount.goods_name}}</strong>
					<div class="goods-company-detail-show" @click="goodsInfo(organ_id, billCount, billCount.organName)">
						<ul class="goods-company-detail-show-ul">
							<li class="detail-bill-fulllist" v-if="billCount.goods_code" style="width: 100%;">品项编号：{{billCount.goods_code}}</li>
							<li>订：
								<template v-if="billCount.organName">
									<span style="padding:1px 0;">明细</span>
								</template>数
								<template v-if="billCount.goods_name">
									量
								</template>
								{{billCount.goods_num}}
							</li>
							<li>含税金额：¥ {{billCount.sub_total}}</li>
							<li v-if="billCount.bill_state === 12 || billCount.bill_state === 13 || billCount.bill_state === 14">发：
								<template v-if="billCount.organName">
									<span style="padding:1px 0;">明细</span>
								</template>数
								<template v-if="billCount.goods_name">
									量
								</template>
								{{billCount.goods_num_send}}
							</li>
							<li v-if="billCount.bill_state === 12 || billCount.bill_state === 13 || billCount.bill_state === 14">含税金额：¥ {{billCount.sub_total_send}}</li>
							<li v-if="billCount.bill_state === 13 || billCount.bill_state === 14">收：
								<template v-if="billCount.organName">
									<span style="padding:1px 0;">明细</span>
								</template>数
								<template v-if="billCount.goods_name">
									量
								</template>
								{{billCount.goods_num_recipient}}
							</li>
							<li v-if="billCount.bill_state === 13 || billCount.bill_state === 14">含税金额：¥ {{billCount.sub_total_recipient}}</li>
						</ul>
					</div>
					<div class="clear-float"></div>
				</div>
			</div>
			<div class="goods-company-summary-wrapper" v-if="goodsTotalInfo.select_detail==1">
				<div v-for="billCount in billCounts" class="goods-company-detail-list">
          <div style="overflow: hidden">
            <span v-if="billCount.bill_state === 10" class="goods-company-status">未处理</span>
            <span v-if="billCount.bill_state === 11" class="goods-company-status">待发货</span>
            <span v-if="billCount.bill_state === 12" class="goods-company-status">已发货</span>
            <span v-if="billCount.bill_state === 13" class="goods-company-status">已收货</span>
            <span v-if="billCount.bill_state === 14" class="goods-company-status">已收货 已确认</span>
            <span v-if="billCount.bill_state === 20" class="goods-company-status">未确认</span>
            <span v-if="billCount.bill_state === 21" class="goods-company-status">已确认</span>
            <strong class="goods-company-detail-name">{{billCount.organName ? billCount.organName : billCount.goods_name}}</strong>
          </div>
					<div class="goods-company-house title-font" v-if="groupByHouse">
						<span>收货仓库：</span>
						<span>{{billCount.storeName? billCount.storeName : ''}}</span>
					</div>
          <div ref="listContainerRef" class="list-container">
            <div class="list-content">
              <div ref="columnContainerRef" class="list-head">
                <div class="column-content">
                  <div class="fixed-column fx-ellipsis">品项名称</div>
                  <div class="list-column fx-ellipsis">订货数量</div>
                  <div class="list-column fx-ellipsis" style="width: 18vw">单位</div>
                  <div class="list-column fx-ellipsis" v-show="gord || groupByHouse">明细备注</div>
                  <div class="list-column fx-ellipsis" v-show="gord && !groupByHouse">辅助单位</div>
                  <div class="list-column fx-ellipsis" v-show="gord && !groupByHouse">辅助数量</div>
                </div>
              </div>
              <div class="list-body">
                <div class="list-body-main">
                  <div class="item-list" v-for="good in billCount.goods">
                    <div class="item-name">{{good.goods_name}}</div>
                    <div class="item-info">{{good.goods_num}}</div>
                    <div class="item-info" style="width: 18vw">{{good.goods_unit}}</div>
                    <div class="item-info" v-show="gord || groupByHouse">{{good.remark}}</div>
                    <div class="item-info" v-show="gord && !groupByHouse">{{good.goods_assist_unit}}</div>
                    <div class="item-info" v-show="gord && !groupByHouse">{{good.goods_assist_unit ? good.goods_assist_num : ''}}</div>
                  </div>
                </div>
              </div>
              <div class="list-bottom">
                <div class="total-content">
                  <div class="list-column">合计: {{getGoodsCount(billCount.goods)}}</div>
                </div>
              </div>
            </div>
          </div>
				</div>
			</div>
		</div>
		<refresh v-show="!show" :cls="cls" :font="font"></refresh>
		<mid-ware v-show="midware" :icon="icon" :midFont="midFont"></mid-ware>
	</div>
	<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	<loading v-show="loading"></loading>
	<get-total v-show="total" ref="cTotal" :filter="filterData" href="/cldEdi/business/getGoodsInfoReportTotal" name="餐企"></get-total>
	<summary-filter ref="summaryShow" v-on:searchPost="getSearchCondition"></summary-filter>
	<fx-share v-model="copyPopShow">
		<template slot="mainContent">
			<div class="order-item-block" v-for="billCount in billCounts">
				<div class="title-name">
					{{ !gord && !groupByHouse ? `订货企业：${store.goodsTotalInfo.restaurant_name}` : '' }}
					{{ billCount.organName ? `订货机构：${billCount.organName}` : billCount.goods_name }}
					{{ billCount.to_date | dateFilterYMD }}
				</div>
				<div class="text-word" v-if="groupByHouse">收货仓库：{{billCount.storeName? billCount.storeName : ''}}</div>
				<div class="item-row" v-for="(good, index) in billCount.goods">
					<div class="item-info">{{ index + 1 }}、{{ good.goods_name }}：{{ good.goods_num }}{{ good.goods_unit }}{{good.goods_assist_unit && gord && !groupByHouse ? ' 辅助：' + good.goods_assist_num + good.goods_assist_unit : ''}}</div>
					<div class="item-remark" v-show="good.remark">备注：{{ good.remark }}</div>
				</div>
			</div>
		</template>
	</fx-share>
	<side-float
		:bottom=40
		@on-click="copyPopShow = !copyPopShow"
		v-if="!midware && goodsTotalInfo.select_detail==1">
	</side-float>
</div>
</template>
<script>
import BillCountFilter from '../components/BillCountFilter'
import GetTotal from '../components/GetCompanyTotal'
import Loading from '../components/loading'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import MidWare from '../components/MidWare'
import Refresh from '../components/refresh'
import NavBar from '../components/NavBar'
import SummaryFilter from '../components/SummaryFilter'
import ExcelExport from '../components/ExcelExport'
import { GlobalStore } from '../store/globalStore'
import FxShare from '../components/Fx-share'
import SideFloat from '../components/SideFloat'
export default {
	data () {
		return {
			midware: false,
			icon: '',
			midFont: '',
			total: false,
			loading: false,
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			queryData: this.$route.query,
			allInfo: null,
			billCounts: [],
			show: true,
			cls: '',
			font: '',
			bill_state: '11',
			sort_method: '0',
			restaurant_id: '',
			organ_id: '',
			start_date: '',
			end_date: '',
			length: 10,
			start: 0,
			filterData: {},
			sec: 1500,
			prevLength: 0,
			restaurant_name: '',
			store: GlobalStore,
			goodsTotalInfo: {},
			gord: true,
			groupByHouse: false,
			copyPopShow: false,
			shortcut: false
		}
	},
	components: {
		'excel-export': ExcelExport,
		'bill-filter': BillCountFilter,
		'get-total': GetTotal,
		'loading': Loading,
		'tips': Tips,
		'tips-auto': TipsAuto,
		'mid-ware': MidWare,
		'refresh': Refresh,
		'navbar': NavBar,
		'summary-filter': SummaryFilter,
		FxShare,
		SideFloat
	},
	created () {
		this.shortcut = this.queryData.shortcut
	},
	mounted () {
		this.summaryFilter()
	},
	watch: {
		gord (bool) {
			this.getGoodsList(bool)
		},
		groupByHouse () {
			this.getGoodsList()
		}
	},
	methods: {
		storeHandle () {
			this.goodsTotalInfo = this.store.goodsTotalInfo
			if (this.goodsTotalInfo.start_date === undefined) {
				var d = new Date()
				var year = d.getFullYear()
				var month = d.getMonth()
				var m = new Date(year, month + 1, 0)
				var day = m.getDate()
				month < 9 ? (month = '0' + (month + 1)) : month = d.getMonth() + 1
				this.goodsTotalInfo.start_date = d.getFullYear() + '-' + month + '-' + '01'
				this.goodsTotalInfo.end_date = d.getFullYear() + '-' + month + '-' + day
			}
			if (this.goodsTotalInfo.restaurant_name === undefined) {
				this.goodsTotalInfo.restaurant_name = '请选择餐企'
			}
			if (this.goodsTotalInfo.restaurant_id === undefined) {
				this.goodsTotalInfo.restaurant_id = ''
			}
			if (this.goodsTotalInfo.sort_method === undefined) {
				this.goodsTotalInfo.sort_method = '0'
			}
			if (this.goodsTotalInfo.bill_state === undefined) {
				this.goodsTotalInfo.bill_state = '11'
			}
			if (this.goodsTotalInfo.select_detail === undefined) {
				this.goodsTotalInfo.select_detail = ''
			}
		},
		dateCut (val) {
			var arr = val.split(' ')
			return arr[0]
		},
		summaryFilter () {
			this.storeHandle()
			var obj = {
				restaurant_name: this.goodsTotalInfo.restaurant_name,
				restaurant_id: this.goodsTotalInfo.restaurant_id,
				organ_name: this.goodsTotalInfo.organ_name,
				organ_id: this.goodsTotalInfo.organ_id,
				bill_state: this.goodsTotalInfo.bill_state,
				sort_method: this.goodsTotalInfo.sort_method,
				start_date: this.goodsTotalInfo.start_date,
				end_date: this.goodsTotalInfo.end_date,
				select_detail: this.goodsTotalInfo.select_detail,
				shortcut: this.shortcut
			}
			this.$refs.summaryShow.open(obj)
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		getSearchCondition (msg) {
			// 获得查询条件开始查询
			var goodsTotalInfo = this.store.goodsTotalInfo
			goodsTotalInfo.bill_state = msg.bill_state
			goodsTotalInfo.sort_method = msg.sort_method
			goodsTotalInfo.select_detail = msg.select_detail //
			goodsTotalInfo.restaurant_id = msg.restaurant_id
			goodsTotalInfo.restaurant_name = msg.restaurant_name
			goodsTotalInfo.organ_id = msg.organ_id
			goodsTotalInfo.organ_name = msg.organ_name
			goodsTotalInfo.start_date = msg.start_date
			goodsTotalInfo.end_date = msg.end_date
			this.start = 0
			this.shortcut = msg.shortcut
			if (this.shortcut === 1) {
				this.groupByHouse = true
			} else {
				this.getGoodsList()
			}
		},
		getGoodsList (groupByOrgan) {
			this.storeHandle()
			this.loading = true
			this.midware = false
			var goodsTotalInfo = this.store.goodsTotalInfo
			var searchCondition = {
				bill_state: goodsTotalInfo.bill_state,
				date_type: goodsTotalInfo.sort_method,
				restaurant_id: goodsTotalInfo.restaurant_id,
				fromOrganId: goodsTotalInfo.organ_id,
				start_date: goodsTotalInfo.start_date,
				end_date: goodsTotalInfo.end_date,
				select_detail: goodsTotalInfo.select_detail,
				group_by_organ: this.gord ? '1' : '0',
				group_by_house: this.groupByHouse ? '1' : '0',
				length: this.length,
				start: this.start
			}
			if (groupByOrgan !== undefined) {
				searchCondition.group_by_organ = groupByOrgan ? '1' : '0'
			}
			this.$http.post('/cldEdi/business/getGoodsInfoReportDetail', searchCondition).then((response) => {
				this.loading = false
				var allInfo = response.body.data
				this.restaurant_name = allInfo.restaurant_name
				this.restaurant_id = allInfo.restaurant_id
				this.organ_id = allInfo.organ_id
				this.start_date = allInfo.startDate
				this.end_date = allInfo.endDate
				this.bill_state = allInfo.bill_state
				this.shortcut = undefined
				if (allInfo.sort_method !== null && allInfo.sort_method !== undefined) {
					this.sort_method = allInfo.sort_method
				}
				this.filterData = {
					bill_state: this.bill_state,
					date_type: goodsTotalInfo.sort_method,
					restaurant_id: this.restaurant_id,
					start_date: this.start_date,
					end_date: this.end_date,
					fromOrganId: this.organ_id
				}
				if (allInfo.organ_id !== undefined) {
					this.goodsTotalInfo.organ_id = this.organ_id
				}
				// 注释有问题吗？？
				if (allInfo.restaurant_name !== undefined) {
					this.goodsTotalInfo.restaurant_id = this.restaurant_id
					this.goodsTotalInfo.restaurant_name = this.restaurant_name
				}
				this.billCounts = response.body.data.details
				if (this.billCounts === undefined) {
					this.total = false
					this.midware = true
					this.icon = 'middle-empty'
					this.midFont = '没有数据'
					return false
				}
				this.prevLength = this.billCounts.length
				this.total = true
			}, (response) => {
				this.loading = false
				this.midware = true
				this.icon = 'middle-net'
				this.midFont = '服务中断，稍后请重试！'
			})
		},
		refresh () {
			var goodsTotalInfo = this.store.goodsTotalInfo
			var el = document.getElementById('common-scroll')
			var marginBot = el.scrollHeight - (el.scrollTop + document.body.scrollTop) - el.clientHeight
			if (marginBot <= 10) {
				this.show = false
				if (this.prevLength < 10 || this.billCounts.length < (this.start + 1) * 10) {
					this.cls = 'remind'
					this.font = '已经没有数据'
					var self = this
					setTimeout(() => {
						self.show = true
					}, 1500)
					return false
				}
				this.cls = 'update'
				this.font = '加载中...'
				this.start ++
				var start = this.start * 10
				var searchCondition = {
					bill_state: goodsTotalInfo.bill_state,
					date_type: goodsTotalInfo.sort_method,
					restaurant_id: goodsTotalInfo.restaurant_id,
					fromOrganId: goodsTotalInfo.organ_id,
					start_date: goodsTotalInfo.start_date,
					end_date: goodsTotalInfo.end_date,
					length: this.length,
					start: start
				}
				this.$http.post('/cldEdi/business/getGoodsInfoReportDetail', searchCondition).then((response) => {
					this.show = true
					var data = response.body.data.details
					if (data) {
						this.prevLength = data.length
						this.billCounts = this.billCounts.concat(data)
					}
				}, (response) => {
					this.loading = false
					this.midware = true
					this.icon = 'middle-net'
					this.midFont = '服务中断，稍后请重试！'
				})
			}
		},
		excelChoose () {
			this.$refs.tipsfRef.open()
		},
		sendExcelSd () {
			// 对接导出excel并发送邮件接口
			this.loading = true
			var goodsTotalInfo = this.store.goodsTotalInfo
			var billDate = {
				bill_state: this.bill_state,
				start_date: this.start_date,
				end_date: this.end_date,
				fromOrganId: this.organ_id,
				restaurant_id: this.restaurant_id, // 餐企ID
				restaurant_name: this.restaurant_name, // 餐企名称
				date_type: goodsTotalInfo.sort_method, // 日期类型
				select_detail: goodsTotalInfo.select_detail,
				group_by_organ: this.gord ? '1' : '0',
				group_by_house: this.groupByHouse ? '1' : '0'
			}
			this.$http.post('/cldEdi/business/send_dtail_group_organ', billDate).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					this.autoTips('邮件已发送至供货商邮箱，请注意查收！')
				} else {
					this.autoTips(data.message)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		sendExcel ({content, style}) {
			if (content === null || style === null) {
				return false
			}
			// 对接导出excel并发送邮件接口
			this.loading = true
			var goodsTotalInfo = this.store.goodsTotalInfo
			var billDate = {
				bill_state: this.bill_state,
				start_date: this.start_date,
				end_date: this.end_date,
				fromOrganId: this.organ_id,
				restaurant_id: this.restaurant_id, // 餐企ID
				restaurant_name: this.restaurant_name, // 餐企名称
				date_type: goodsTotalInfo.sort_method, // 日期类型
				date_content: content + '', // 内容 0: 金额 1: 数量 2: 金额和数量
				exportType: style + 1 + '' // 导入方式  1: 以品项为列  2: 以门店为列
			}
			this.$http.post('/cldEdi/business/8002', billDate).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					this.autoTips('邮件已发送至供货商邮箱，请注意查收！')
				} else {
					this.autoTips(data.message)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		goodsInfo (oid, item, oName) { // 如果是门店，跳商品信息接口；如果商品跳货品汇总-机构页
			var el = document.getElementById('common-scroll')
			el.scrollTop = 0
			if (oid === '') { // 跳商品详情
				var goodsTotalInfo = this.store.goodsTotalInfo
				var params = {
					bill_state: item.bill_state,
					date_type: goodsTotalInfo.sort_method,
					restaurant_id: item.restaurant_id,
					fromOrganId: item.organ_id,
					start_date: goodsTotalInfo.start_date,
					end_date: goodsTotalInfo.end_date,
					length: this.length,
					start: 0
				}
				this.filterData.bill_state = item.bill_state
				this.bill_state = item.bill_state
				this.goodsTotalInfo.organ_name = oName
				// this.goodsTotalInfo.bill_state = String(item.bill_state)
				this.$http.post('/cldEdi/business/getGoodsInfoReportDetail', params).then((response) => {
					this.loading = false
					this.billCounts = response.body.data.details
					this.organ_id = response.body.data.organ_id
					this.filterData.fromOrganId = this.organ_id
					this.store.goodsTotalInfo.organ_id = this.organ_id
					this.prevLength = this.billCounts ? this.billCounts.length : 0
				}, (response) => {
					this.loading = false
					this.midware = true
					this.icon = 'middle-net'
					this.midFont = '服务中断，稍后请重试！'
				})
			} else { // 跳货品汇总-机构
				this.$router.push({ path: '/goods-organ-summary', query: {
					organ_id: this.organ_id,
					restaurant_id: this.restaurant_id,
					goods_id: item.goods_id,
					bill_state: this.bill_state,
					sort_method: this.goodsTotalInfo.sort_method,
					restaurant_name: this.goodsTotalInfo.restaurant_name,
					start_date: this.start_date,
					end_date: this.end_date,
					goods_unit: item.goods_unit }
				})
			}
		},
		getGoodsCount (goods) {
			var count = 0
			goods && goods.forEach(g => {
				count += g.goods_num
			})
			return this.$fxUtils.toFixed(count, 4)
		}
	}
}
</script>



// WEBPACK FOOTER //
// GoodsCompanySummary.vue?7bb197bc